/*
 * File: components/admin/EmployeeManagement.js
 * Mô tả: Component container gộp các chức năng quản lý nhân viên.
 * CẬP NHẬT: Đọc tab từ URL thay vì dùng useState để đồng bộ với Sidebar bên trái.
 */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminEmployeeCheck from './CheckEmployee';
import UserManagementComponent from './UserManagement';
import AddEmployee from './AddEmployee';
import EmployeeList from './EmployeeList';
import BasicCodeManagement from './BasicCodeManagement';
import MappingMaChamCong from './MappingMaChamCong';

export default function EmployeeManagement() {
    const location = useLocation();
    const navigate = useNavigate();

    // 1. Đọc tham số '?tab=' từ URL. Mặc định là 'list' nếu không có tham số nào.
    const queryParams = new URLSearchParams(location.search);
    const activeTab = queryParams.get('tab') || 'list';

    // 2. Hàm xử lý khi bấm vào các nút tab nội bộ (cập nhật lại URL)
    const handleTabChange = (tabName) => {
        navigate(`/employee?tab=${tabName}`);
    };

    return (
        <div>
            {/* Hiển thị component tương ứng với tab trên URL */}
            <div className="animate-fade-in">
                {activeTab === 'list' && <EmployeeList />}
                {activeTab === 'add' && <AddEmployee />}
                {activeTab === 'check' && <AdminEmployeeCheck />}
                {activeTab === 'manage' && <UserManagementComponent />}
                {activeTab === 'basic_code' && <BasicCodeManagement />}
                {activeTab === 'mapping' && <MappingMaChamCong />}
            </div>
        </div>
    );
}